// export const devStuIndex = "http://192.168.1.22:8081";
export const devStuIndex = "http://192.168.1.82:8080";

export const tfStuIndex = "https://tfwww.jiudou123.com";

export const proStuIndex = "https://www.jiudou123.com";
